import { render, staticRenderFns } from "./PaginationComponent.vue?vue&type=template&id=4e426515&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"
import style0 from "./PaginationComponent.vue?vue&type=style&index=0&id=4e426515&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e426515",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e426515')) {
      api.createRecord('4e426515', component.options)
    } else {
      api.reload('4e426515', component.options)
    }
    module.hot.accept("./PaginationComponent.vue?vue&type=template&id=4e426515&scoped=true", function () {
      api.rerender('4e426515', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/PaginationComponent.vue"
export default component.exports